import { Button, Stack, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import WhiteHouseSvg from '~/@ui/_sharedSvgs/FontAwesome/WhiteHouse.svg?react'

type Props = {
  className?: string
}

export const NewRequest = ({ className = '' }: Props) => {
  return (
    <Stack className={`px-4 pt-5 pb-4 bg-zBlack300 rounded-4d ${className}`}>
      <Stack className="flex-row items-center gap-3">
        <WhiteHouseSvg />
        <Typography className="text-base font-bold text-zWhite200">
          Získajte druhý dôchodok
        </Typography>
      </Stack>
      <Typography className="text-3d font-medium text-zGrey450 mt-3">
        Využite hodnotu svojej nehnuteľnosti na bezstarostné časy dôchodku.
      </Typography>
      <Button
        to="/vlastnik/dotaznik/informacie-o-ziadatelovi"
        component={Link}
        variant="contained"
        className="w-fit h-11 px-6 bg-zWhite200 text-3d font-medium text-zBlack200 mt-3.5">
        Vytvoriť žiadosť
      </Button>
    </Stack>
  )
}
